import React from 'react';
import type { QuoteSummary } from '@dopomogai/types';
import { QuoteListItem } from './QuoteListItem';

type Props = {
  quotes: QuoteSummary[];
  className?: string;
};

export function QuoteList({ quotes, className }: Props) {
  return (
    <div className={className}>
      {quotes.map((q) => (
        <QuoteListItem key={q.id} quote={q} />
      ))}
    </div>
  );
}
